// AI Generated Component
import { Component, Input, OnInit } from '@angular/core';
import { SessionService } from '@monsido/core/session/session.service';

@Component({
    selector: 'seo-information-missing-alt',
    standalone: false,
    template: `
        <div class="seo-information-missing-alt">
            <h5>
                <span translate>Image missing alt attribute</span>
                <span *ngIf="count(seo.content) > 1" translate>Images missing alt attribute</span>
            </h5>
            <table class="table seo-missing-alt-issue">
                <tr *ngFor="let image of $any(seo.content); let i = index; trackBy: trackByIndex">
                    <td class="col-1" aria-label="Index of image found">
                        {{ i + 1 }}.
                    </td>
                    <td class="col-8" aria-label="Link to image">
                        <a [href]="image.url"
                           target="_blank" aria-describedby="linkOpensInNewTab"
                           alt="Visit the affected image">
                            <img [src]="image.url"
                                 alt="Affected image"
                                 class="img-responsive img-thumbnail">
                        </a>
                    </td>
                    <td class="col-40" aria-label="Link presentation of image">
                        <a [href]="image.origurl"
                           target="_blank" aria-describedby="linkOpensInNewTab"
                           alt="Image's link">{{ image.origurl }}</a>
                    </td>
                </tr>
            </table>
        </div>
    `,
})
export class SeoInformationMissingAltComponent implements OnInit {
    @Input() seo: any;
    @Input() page: any;

    domainUrl: any;

    constructor (private sessionService: SessionService) {}

    ngOnInit (): void {
        this.domainUrl = this.sessionService.domain?.url;
    }

    count (content: any): number {
        if (Array.isArray(content)) {
            return content.length;
        } else if (content === null || content === undefined) {
            return 0;
        }
        return 1;
    }

    trackByIndex (index: number, item: any): number {
        return index;
    }
}
